/* eslint-disable */
import { useEffect } from 'react';
import { config } from '@app/config';

const useForter = () => {
  useEffect(() => {
    const newScript = document.createElement('script');
    newScript.async = true;
    if (config.ENVIRONMENT === 'production') {
      newScript.src = 'https://web-assets.stockx.com/scripts/forter-prod.js';
    } else {
      newScript.src = 'https://web-assets.stockx.com/scripts/forter-staging.js';
    }
    document?.querySelector('body')?.appendChild(newScript);
  }, []);
};

export default useForter;
